export function getContext() {
  return null;
}

export function runWithRequestContext(context, fn) {
  return null;
}